export default "__VITE_ASSET__4b480f46__"